var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "StatusChip",
    _vm._b(
      {
        attrs: {
          title: "File Version",
          closeOnContentClick: false,
          text: _vm.versionStatus.text,
          icon: _vm.versionStatus.icon,
          iconColor: _vm.versionStatus.iconColor,
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return _vm._l(_vm.fileVersions, function (version, index) {
                return _c(
                  "v-list-tile",
                  {
                    key: index,
                    class: { "card-bg-2": version.isCurrent },
                    attrs: { inactive: version.isCurrent },
                    on: {
                      click: function ($event) {
                        return _vm.onClick(version)
                      },
                    },
                  },
                  [
                    _c(
                      "v-list-tile-avatar",
                      [
                        version.isIngested
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  color:
                                                    version.hasIngestionError
                                                      ? "error"
                                                      : "info",
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    version.hasIngestionError
                                                      ? "cloud_off"
                                                      : "cloud_done"
                                                  ),
                                                },
                                              },
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                version.hasIngestionError
                                  ? _c("span", [
                                      _vm._v(
                                        "This data file could not be ingested."
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "This data file was ingested successfully."
                                      ),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-list-tile-title", { staticClass: "clickable" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.getVersionDate(version)) +
                          "\n        "
                      ),
                      version.isCurrent
                        ? _c("span", { staticClass: "info--text pl-1" }, [
                            _vm._v("(current)"),
                          ])
                        : index == 0
                        ? _c("span", { staticClass: "pl-1" }, [
                            _vm._v("(latest)"),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              })
            },
            proxy: true,
          },
        ]),
      },
      "StatusChip",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }